export default {
    allIdeas: [],
    showIdeas: {},
    ideaDeleteId: '',
    pagination: {},
    searchQuery: "",
    }